import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

// Here, we fire "impression" events when the component mounts to the screen, regardless if it is in-view or hidden via CSS (mobile screen)
// "View" events are fired when a customer has the ad in the viewport, via intersection observer
const MicrosoftAdsWrapper = ({ children, impressionUrl, trackMicrosoftAdImpressions, viewUrl }) => {
  const [intersectionRef, inView] = useInView({ threshold: 0.3 /** 30% was the agreed upon spec from MSFT to fire the view event */, triggerOnce: true });
  useEffect(() => {
    trackMicrosoftAdImpressions({ url: impressionUrl });
  }, [impressionUrl, trackMicrosoftAdImpressions]);

  useEffect(() => {
    if (inView) {
      trackMicrosoftAdImpressions({ url: viewUrl });
    }
  }, [inView, trackMicrosoftAdImpressions, viewUrl]);

  return children(intersectionRef);
};

export default MicrosoftAdsWrapper;
